import { usePostCartsBuyHook } from '@api-product/🧺-корзина-🔓/🧺-корзина-🔓';
import { useCart } from '@hooks/queries/use-query-cart';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { BuyCartData, PromocodeErrorCode } from '@/shared/types/cart';
import { useStore } from '@/store/context';

type ErrorInfo = {
  title: string;
  text: string;
};

type OrderErrors = Record<PromocodeErrorCode, ErrorInfo>;

const orderErrors: OrderErrors = {
  INVENTORY_LIMIT: {
    title: 'Limit!',
    text: 'The inventory is limited to 10 slots. You don’t have enough space to purchase more items. To free up space, transfer some items to the game',
  },
  CART_DATA_NOT_ACTUAL: {
    title: 'Oops!',
    text: ' Some items have sold out and are no longer available to buy',
  },
  PROMOCODE_REJECTED: {
    title: 'Oops!',
    text: 'The promo code entered is invalid or does not meet the minimum requirements. Please use a different promo code',
  },
  PAYMENT_METHOD_REJECTED: {
    title: 'Oops!',
    text: 'Something went wrong',
  },
  VALIDATION_ERROR: {
    title: 'Oops!',
    text: 'Something went wrong',
  },
};

export const useCreateOrder = () => {
  const buyCart = usePostCartsBuyHook();
  const notificationStore = useStore().notifications;
  const router = useRouter();
  const { refetch: refetchCart } = useCart();
  const [isFetching, setIsFetching] = useState(false);

  const createOrder = async (data: BuyCartData) => {
    setIsFetching(true);
    try {
      const response = await buyCart(data);
      refetchCart();
      if (
        response.data.status === 'PLACED' ||
        response.data.status === 'PAID' ||
        response.data.status === 'PENDING'
      ) {
        router.push(`/order/${response.data.orderId}`);
      }
    } catch (err: any) {
      notificationStore.addNotification({
        id: 'order-error',
        title:
          orderErrors[err.response.data.error.code as PromocodeErrorCode].title,
        subtitle:
          orderErrors[err.response.data.error.code as PromocodeErrorCode].text,
        variant: 'error',
        delay: 30,
      });
    }
    setIsFetching(false);
  };

  return { isFetching, createOrder };
};
